import { ioc } from '../ioc';
import { iocGetApiAddress } from './getApiAddresss';
import { iocGetParameterByName } from './getParameterByName';

export const getParameterByName = ioc.inject(iocGetParameterByName);
export const getApiAddress = ioc.inject(iocGetApiAddress);
